import apiClient, { isNetworkError } from "../api/client";
import { getSyncQueue, removeSyncItem, updateSyncItem } from "./offlineStore";

const MAX_RETRIES = 5;
const BASE_DELAY = 5000; // 5s initial
let syncRunning = false;
let syncInterval = null;

export async function processSyncQueue() {
  if (syncRunning) return;
  syncRunning = true;

  try {
    const queue = await getSyncQueue();
    if (queue.length === 0) return;

    for (const item of queue) {
      if (item.retries >= MAX_RETRIES) {
        // Give up after max retries
        await removeSyncItem(item.id);
        continue;
      }

      try {
        if (item.type === "submit_round") {
          await apiClient.post("/rounds", item.payload);
          await removeSyncItem(item.id);
        } else if (item.type === "update_round") {
          await apiClient.put(`/rounds/${item.roundId}`, item.payload);
          await removeSyncItem(item.id);
        }
      } catch (err) {
        if (isNetworkError(err)) {
          // Still offline — increment retry, try later
          await updateSyncItem({ ...item, retries: item.retries + 1, lastAttempt: Date.now() });
          break; // Stop processing queue if network is down
        } else {
          // Server rejected it (400, 409, etc.) — remove from queue
          await removeSyncItem(item.id);
        }
      }
    }
  } finally {
    syncRunning = false;
  }
}

export function startSyncScheduler() {
  if (syncInterval) return;
  // Process immediately, then every 30 seconds
  processSyncQueue();
  syncInterval = setInterval(processSyncQueue, 30000);

  // Also sync when coming back online
  window.addEventListener("online", processSyncQueue);
}

export function stopSyncScheduler() {
  if (syncInterval) {
    clearInterval(syncInterval);
    syncInterval = null;
  }
  window.removeEventListener("online", processSyncQueue);
}

export async function getPendingSyncCount() {
  const queue = await getSyncQueue();
  return queue.length;
}
